module.exports = __webpack_public_path__ + "img/banner-35.jpg";